module.exports = "<app-company-ae-table #companyaeTableComponent (emitEditCase)=\"editCaseHandler($event)\" (createButtonClick)=\"createCaseHandler($event)\"></app-company-ae-table>\n<div id=\"companyAddCaseScroll\">\n    <app-company-ae-form-add *ngIf=\"displayAddPage\" (onFinished)=\"onFinished($event)\" [createFormData]=\"createFormData\"></app-company-ae-form-add>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/company-ae/company-ae.component.html
// module id = ../../../../../src/app/admin/company-ae/company-ae.component.html
// module chunks = main